import { render } from "./GiftDepositElement.vue?vue&type=template&id=6ee7b6c0&scoped=true"
import script from "./GiftDepositElement.vue?vue&type=script&lang=js"
export * from "./GiftDepositElement.vue?vue&type=script&lang=js"

import "./GiftDepositElement.vue?vue&type=style&index=0&id=6ee7b6c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee7b6c0"]])

export default __exports__